module.exports = " <div v-if=active> <div class=mask></div> <div class=toast v-if=active> <div class=\"icon loading\"></div> <p class=message>载入中</p> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 126
// module chunks = 1